import { Navbar } from "./navbar"


import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import homeImg1 from "../assets/images/homeImg1.jpg"
import homeImg2 from "../assets/images/homeImg2.jpg"
import homeImg3 from "../assets/images/homeImg3.jpg"
import homeImg4 from "../assets/images/homeImg4.jpg"
import homeImg5 from "../assets/images/homeImg5.jpg"
import homeImg6 from "../assets/images/homeImg6.jpg"
import homeImg7 from "../assets/images/homeImg7.jpg"
import homeImg8 from "../assets/images/homeImg8.jpg"
import test1 from "../assets/images/test1.png"
import test2 from "../assets/images/test2.png"

import barkan from "../assets/images/barkan.png"
import beacon from "../assets/images/beacon.png"
import aptManage from "../assets/images/aptManage.png"
import firstReality from "../assets/images/firstReality.png"
import peabody from "../assets/images/peabody.png"
import coverVideo from "../assets/video/coverVideo.mp4"
import coverVideowebm from "../assets/video/coverVideo.webm"
import coverVideomov from "../assets/video/coverVideo.mov"
import videoPoster from "../assets/images/banner.jpg"

import { Footer } from "./footer"
import { Link } from "react-router-dom";


export const Home = () =>{
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 5,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              arrows: false,
            },
          },
        ],
      };

    return(
        <div className="homePage">
            <header>
                <div className="container">
                    <Navbar />
                    <div className="headerContent">
                        <h1>New England Roofing Services at its Best!</h1>
                        <p>Reliable Roof Repair & Installation You Can Trust</p>
                        <div className="btnDiv">
                            <button className="blueBtn me-3">Commercial</button>
                            <button className="whiteBtn">Residential</button>
                        </div>
                    </div>
                </div>
                <video autoPlay={true} muted="true" loop={true} playsInline={true} poster={videoPoster} >
                    <source src={coverVideo} type="video/mp4" />
                    <source src={coverVideowebm} type="video/webm" />
                    <source src={coverVideomov} type="video/mov" />
                    Your browser does not support the video tag.
                </video>
            </header>

            <section className="reliabilitySec"> 
                <div className="container">
                    <h1 className="heading56 mb-4">Reliability Starts at the <span>Top!</span></h1>
                    <div className="titileText">Corolla Roofing provides professional commercial and residential roofing services ranging from snow removal to new roof installation.</div>
                    <div className="row">
                        <div className="col-lg-6 order-lg-1 order-2">
                            <p className="text22 mb-0">Our experienced and trained team members work hard to ensure a quality roof product for our clients.</p>
                            <p className="text22">We work with any size home or commercial building using various materials, including metal roofs, shingles, EPDM, slate repairs, modified roofs, and systems like PVC Thermal Plastic. This breadth of specialty allows us to find customized solutions for any project, regardless of scope.</p>
                            <Link to="/about" className="blueOutlineBtn mt-4">More About Us</Link>
                        </div>
                        <div className="col-lg-5 order-lg-2 order-1 text-center">
                            <div className="imgDiv">
                                <img src={homeImg1} alt="homeImg1" className="img-fluid" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            
            <section className="ourMissinSec"> 
                <div className="container">
                    <div className="row ai-center">
                        <div className="col-lg-5">
                            <div className="text-center">
                                <img src={homeImg2} alt="homeImg1" className="img-fluid" />
                            </div>
                        </div>
                        <div className="col-lg-7">
                            <div className="content">
                                <h1 className="heading56 mb-4">Our  <span>Mission</span></h1>
                                <p className="text22">Deliver quality roofing installation and repair services to all our clients, so we remain the leading choice in commercial and residential roofing for all of New England.</p>
                                <Link to="/contact" className="blueOutlineBtn mt-4">Contact Us</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="projectSec">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-3 col-6">
                            <div className="col2">
                                <p>Years of <br /> Experience</p>
                                <h1>30+</h1>
                            </div>
                        </div>
                        <div className="col-lg-3 col-6">
                            <div className="col2">
                                <p>Project <br /> Completed</p>
                                <h1>260</h1>
                            </div>
                        </div>
                        <div className="col-lg-3 col-6">
                            <div className="col2">
                                <p>Contractors <br /> Appointed</p>
                                <h1>870</h1>
                            </div>
                        </div>
                        <div className="col-lg-3 col-6">
                            <div className="col2">
                                <p>Client <br /> Satisfaction</p>
                                <h1>100%</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="ourServiceSec"> 
                <div className="container">
                    <h1 className="heading56 mb-4">Our <span>Services</span></h1>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="col1 ">
                                <h2>Commercial Roofing</h2>
                                <p>Corolla Roofing works with businesses, institutions, and other commercial properties to create long-lasting solutions.</p>
                                <div className="imgDiv">
                                    <img className="img-fluid" src={homeImg3} alt="" />
                                </div>
                                <button className="blueOutlineBtn w-100 mt-4">Learn More</button>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="col1 ms-auto">
                                <h2>Commercial Roofing</h2>
                                <p>Our team at Corolla Roofing knows how to blend the aesthetic needs of our residential clients with the operational security of a durable roofing solution.</p>
                                <div className="imgDiv">
                                    <img className="img-fluid" src={homeImg4} alt="" />
                                </div>
                                <button className="blueOutlineBtn w-100 mt-4">Learn More</button>
                            </div>
                        
                        </div>
                    </div>
                </div>
            </section>

            <section className="projectSec">
                <div className="container">
                    <h1 className="heading56 mb-4">Our <span>Projects</span></h1>
                    <div className="row">
                        <div className="col-md-4">
                           <ProjectCard image={homeImg5} title="COMMERCIAL" desc="Seal Harbor 3, Winthrop, MA" />
                        </div>
                        <div className="col-md-4">
                           <ProjectCard image={homeImg6} title="Residential" desc="Shrewsbury Commons Apartments" />
                        </div>
                        <div className="col-md-4">
                           <ProjectCard image={homeImg7} title="COMMERCIAL" desc="Glass Factory, Cambridge, MA" />
                        </div>
                    </div>
                    <div className="text-center">
                        <button className="blueOutlineBtn mt-5">View All Projects</button>
                    </div>
                </div>
            </section>

            <section className="testimonialSec">
                <div className="container">
                    <h1 className="heading56 mb-4">Our <span>Testimonials</span></h1>
                    <div className="row">
                        <div className="col-md-6">
                            <TestCard 
                            image={test1}
                            name="E. Denis Walsh," 
                            desc="I cannot tell you how pleased we are with the new 100,000 square foot roof… The job came in on time, on budget and with very few change orders...." 
                            company="Welsh Management Co., Inc."  
                            />
                        </div>
                        <div className="col-md-6">
                            <TestCard 
                            image={test2}
                            name="Mark L. Glater" 
                            desc="Never in my business experience have I ever met a pro-active company as yours. The communication I received daily and the lack of my time following..." 
                            company="Elite Management & Development Corp."  
                            />
                        </div>
                    </div>
                </div>
            </section>

            <section className="getTouchSec">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="imgDiv">
                                <img className="img-fluid" src={homeImg8} alt="" />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <h1 className="heading56 mb-4">Get <span>In Touch</span></h1>
                            <form >
                                <p className="text22 mb-4">We take great pride in everything that we do, complete control over products allows us to ensure our customers receive the best quality service.</p>
                                <div className="d-flex mb-4">
                                    <input required className="form-control me-3" type="text" placeholder="Name" />
                                    <input required className="form-control" type="email" placeholder="Email" />
                                </div>
                                <div className="d-flex mb-4">
                                    <input required className="form-control me-3" type="text" placeholder="Phone" />
                                    <input required className="form-control" type="text" placeholder="Subject" />
                                </div>
                                <div className="">
                                    <textarea className="form-control" name="" placeholder="Additional Details" cols="10" rows="5"></textarea>
                                </div>
                                <button type="submit" className="blueBtn mt-5">Submit</button>
                            </form>
                        </div>
                    </div>
                </div>
            </section>

            <section className="companyslider">
                <div className="container">
                    <Slider {...settings}>
                      <div className="col px-3">
                        <img className="img-fluid" src={barkan} alt="barkan" />
                      </div>
                      <div className="col px-3">
                        <img className="img-fluid" src={beacon} alt="beacon" />
                      </div>
                      <div className="col px-3">
                        <img className="img-fluid" src={aptManage} alt="aptManage" />
                      </div>
                      <div className="col px-3">
                        <img className="img-fluid" src={firstReality} alt="firstReality" />
                      </div>
                      <div className="col px-3">
                        <img className="img-fluid" src={peabody} alt="peabody" />
                      </div>
                      <div className="col px-3">
                        <img className="img-fluid" src={barkan} alt="barkan" />
                      </div>
                    </Slider>
                </div>
            </section>

        </div>
    )
}

const ProjectCard = ({image,title,desc}) =>{
    return(
    <div className="projectCard">
        <div className="imgDiv">
            <img className="img-fluid" src={image} alt="home" />
        </div>
        <p className="title">{title}</p>
        <p className="desc">{desc}</p>
    </div>
    )
}
const TestCard = ({image,name,desc,company}) =>{
    return(
    <div className="testCard">
        <div className="logo">
            <img src={image} alt="" />
        </div>
        <div>
            <p>{desc}</p>
            <h3>{name}</h3>
            <p className="cName">{company}</p>
        </div>
    </div>
    )
}